import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { connect } from 'react-redux';
import { debounce } from 'lodash';

import { updateLeadFields } from 'bundles/project/actions/leads';
import { SAVE_ERROR_TEXT, saveErrorText } from 'bundles/leads/helper/save_error_text';
import SaveMessage from 'bundles/project/components/leads/show/save_message';
import { getPossibleLeadReferralSources } from 'bundles/project/selectors/leads';

const SAVE_STATUS_MESSAGE_TIMEOUT = 3000;

export class LeadReferralSourceSelect extends React.Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    lead: PropTypes.shape({
      referralSource: PropTypes.number,
      source: PropTypes.string
    }).isRequired,
    referralSources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    selectComponent: PropTypes.elementType,
    onSave: PropTypes.func.isRequired,
    onSaveMessage: PropTypes.func
  };

  static defaultProps = {
    selectComponent: Select
  };

  state = {
    saving: false,
    referralSource: this.props.lead.referralSource
  };

  componentDidUpdate(prevProps) {
    const { lead } = this.props;
    if (prevProps.lead.referralSource !== lead.referralSource) {
      // Ensure state reflects latest status in DB
      this.setState({ referralSource: lead.referralSource });
    }
  }

  clearMessage = () => this.setState({ message: undefined });
  debouncedClearMessage = debounce(this.clearMessage, SAVE_STATUS_MESSAGE_TIMEOUT);

  handleSaveComplete = (newMessage) => {
    if (this.props.onSaveMessage) {
      this.props.onSaveMessage(newMessage);
      return;
    }

    this.setState({ message: newMessage });
    this.debouncedClearMessage();
  };

  handleSave = (selectedReferralSource) => {
    const { lead, onSave } = this.props;
    const selectedReferralSourceId = selectedReferralSource && selectedReferralSource.id;

    this.setState({ referralSource: selectedReferralSourceId, message: undefined });
    onSave(lead, { projectsLeadReferralSourceId: selectedReferralSourceId }).then(() => {
      this.handleSaveComplete({ type: 'success', text: 'Successfully saved' });
    }).catch((errors) => {
      const text = this.props.onSaveMessage ? saveErrorText(errors) : SAVE_ERROR_TEXT;
      this.setState({ referralSource: this.props.lead.referralSource });
      this.handleSaveComplete({ type: 'error', text });
    });
  };

  render() {
    const { ariaLabel, referralSources, selectComponent: SelectComponent } = this.props;
    const selectedValue = this.state.referralSource &&
      referralSources.find(status => status.id === this.state.referralSource);

    return (
      <React.Fragment>
        <SelectComponent
          aria-label={ariaLabel}
          getOptionLabel={option => option.label}
          getOptionValue={option => option.id}
          isClearable={true}
          name="lead-referral-source-select"
          options={referralSources}
          value={selectedValue}
          onChange={this.handleSave}
        />
        <SaveMessage className="top-buffer-sm" message={this.state.message} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  referralSources: getPossibleLeadReferralSources(state)
});

const mapDispatchToProps = {
  onSave: updateLeadFields
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadReferralSourceSelect);
